import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FunnelConfig } from '../view-project-new/funnel/funnel.logic';
import { buildFunnelView, FunnelViewModel } from './funnel-view.logic';

/**
 * The leads screen as a funnel: every outcome count sits in the stage the owner
 * chose in Funnel, widest (lowest priority) band on top, goal band at the bottom.
 * Clicking an outcome filters the lead list the same way its tile does.
 */
@Component({
  selector: 'hour4u-admin-connected-funnel',
  templateUrl: './connected-funnel.component.html',
  styleUrls: ['./connected-funnel.component.scss']
})
export class ConnectedFunnelComponent implements OnChanges {
  @Input() config: FunnelConfig;
  @Input() statusCounts: { [status: string]: number } = {};
  @Input() activeStatuses: string[] = [];
  @Output() selectStatus = new EventEmitter<string>();
  @Output() editFunnel = new EventEmitter<void>();

  view: FunnelViewModel | null = null;

  ngOnChanges() {
    this.view = this.config ? buildFunnelView(this.config, this.statusCounts) : null;
  }

  isActive(status: string): boolean {
    return this.activeStatuses.indexOf(status) !== -1;
  }

  trackByIndex(i: number) { return i; }
}
